import { ManagerProfile } from '../../domain/ManagerProfile';

// picture/gender are not part of the real contract yet — optional, read defensively (see
// domain/ManagerProfile.ts).
type ManagerProfileDto = {
  uuid: string;
  email: string;
  first_name: string;
  last_name: string;
  language: string;
  organization: { uuid: string; name: string } | null;
  picture?: { photo: string } | null;
  gender?: string | null;
};

// v2 sends BCP 47 tags (`en-US`); the platform uses its legacy locale codes (`en_us`). Same
// conversion as the backend's `bcp47_to_locale`.
const toPlatformLanguage = (tag: string): string => tag?.replace('-', '_').toLowerCase();

const mapManagerProfileDtoToDomain = (dto: ManagerProfileDto): ManagerProfile =>
  ManagerProfile.create({
    uuid: dto.uuid,
    email: dto.email,
    firstName: dto.first_name,
    lastName: dto.last_name,
    language: toPlatformLanguage(dto.language),
    organization: dto.organization,
    picture: dto.picture ?? null,
    gender: dto.gender ?? null,
  });

export { mapManagerProfileDtoToDomain };
export type { ManagerProfileDto };
